import React from 'react';
import './AppToolUrl.css';

class AppToolUrl extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      originalString: "",
      outputString: "",
      error: null,
      copySuccess: '',
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleEncode = this.handleEncode.bind(this);
    this.handleDecode = this.handleDecode.bind(this);
    this.handleBase64Encode = this.handleBase64Encode.bind(this);
    this.handleBase64Decode = this.handleBase64Decode.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
  }

  handleChange(e){
    const str = e.target.value;
    this.setState({
      originalString: str,
      outputString: "",
      error: null,
      copySuccess: ''
    });
  }

  handleEncode() {
    const str = this.state.originalString;
    try {
      const encoded = encodeURIComponent(str);
      this.setState({ outputString: encoded, error: null });
    } catch (e) {
      this.setState({ error: 'URL编码失败: ' + e.message, outputString: '' });
    }
  }

  handleDecode() {
    const str = this.state.originalString;
    try {
      const decoded = decodeURIComponent(str);
      this.setState({ outputString: decoded, error: null });
    } catch (e) {
      this.setState({ error: 'URL解码失败: ' + e.message, outputString: '' });
    }
  }

  handleBase64Encode() {
    const str = this.state.originalString;
    try {
      const encoded = btoa(unescape(encodeURIComponent(str)));
      this.setState({ outputString: encoded, error: null });
    } catch (e) {
      this.setState({ error: 'Base64编码失败: ' + e.message, outputString: '' });
    }
  }

  handleBase64Decode() {
    const str = this.state.originalString;
    try {
      const decoded = decodeURIComponent(escape(atob(str)));
      this.setState({ outputString: decoded, error: null });
    } catch (e) {
      this.setState({ error: 'Base64解码失败: ' + e.message, outputString: '' });
    }
  }

  copyToClipboard() {
    if (!this.state.outputString) return;
    navigator.clipboard.writeText(this.state.outputString).then(() => {
      this.setState({ copySuccess: 'Copied!' });
      setTimeout(() => this.setState({ copySuccess: '' }), 2000);
    }, () => {
      this.setState({ copySuccess: 'Failed to copy!' });
      setTimeout(() => this.setState({ copySuccess: '' }), 2000);
    });
  }

  render() {
    const { originalString, outputString, error, copySuccess } = this.state;

    return (
      <div id="tool_url">
        <div id="content_box">
          <textarea 
              rows="8" 
              placeholder='请输入需要URL编码/解码或Base64编码/解码的内容...'
              onChange={this.handleChange}
              value={originalString}
          ></textarea>

          <div className="toolbar">
            <button onClick={this.handleEncode}>URL编码</button>
            <button onClick={this.handleDecode}>URL解码</button>
            <button onClick={this.handleBase64Encode}>Base64编码</button>
            <button onClick={this.handleBase64Decode}>Base64解码</button>
          </div>

          {(outputString || error) && (
            <div>
              {error ? (
                <pre className="error-message">{error}</pre>
              ) : (
                <div>
                  <div className="toolbar">
                    <button onClick={this.copyToClipboard}>Copy</button>
                    {copySuccess && <span className="copy-success">{copySuccess}</span>}
                  </div>
                  <textarea 
                    readOnly
                    rows="8"
                    value={outputString}
                    className="output-area"
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default AppToolUrl;